//angular imports
import { 
  Signal, 
  WritableSignal, 
  computed, 
  signal 
} from "@angular/core";

//local imports
import { IMenu } from "@app/core";
import { IListItem, ListItem, Messenger } from "@app/shared";
import { TypedNavItem, AbstractProjectModel  } from "@app/catalog-common";

export abstract class AbstractProjectNavModel<TProject extends AbstractProjectModel>
  extends TypedNavItem<ListItem<TProject>>
  implements IMenu
{
  public isLoading?: Signal<boolean>;
  public subMenu?: WritableSignal<IMenu> = signal<IMenu>(null);

  constructor(
    protected messenger: Messenger,
    items: Signal<TProject[]>,
    isLoading?: Signal<boolean>
  ) {
    super();

    this.isLoading = isLoading ?? signal<boolean>(false);
    this.items = computed(() =>
      items()
      ?.sort((a,b)=>a.name() > b.name() ? 1 : -1)
      ?.map(item => item?.toListItem$(item.isChecked)),
    );
  }


  public abstract select(item: IListItem): void;
}
